// src/data/planLimits.js
// Single source of truth for per-plan feature limits.
// Both client logic and display copy should read from here.

export const PLAN_LIMITS = {
    free: {
        capsules: 1,
        contacts: 1,         // 1 trusted contact per capsule
        fileSizeMB: 10,      // 10 MB per file
        filesPerCapsule: 1,
        scheduledDelivery: true,
        familyTreeTemplate: false,
        collaborators: false, // No collaborators on free
    },
    starter: {
        capsules: 3,          // Up to 3 capsules
        contacts: 3,          // 3 trusted contacts per capsule
        fileSizeMB: 20,      // 20 MB per file
        filesPerCapsule: 2,
        scheduledDelivery: true,
        familyTreeTemplate: true,
        collaborators: true,  // Collaborators available on paid plans
    },
    legacy: {
        capsules: Infinity,
        contacts: 3,          // 3 trusted contacts per capsule
        fileSizeMB: 30,      // 30 MB per file
        filesPerCapsule: 4,
        scheduledDelivery: true,
        familyTreeTemplate: true,
        collaborators: true,  // Collaborators available on paid plans
    },
};

export const PLAN_LABELS = {
    free: 'Free',
    starter: 'Starter',
    legacy: 'Legacy',
};

// Annual prices in USD
export const LEGACY_ANNUAL_PRICE = 50;
export const STARTER_ANNUAL_PRICE = 25;
